import PicklistMetadata from "../PicklistMetadata";

// Which job reaches for a credential set -- Ataccama's Default / Interactive / Write /
// Operational. A connection test asks for Interactive and falls back to Default.
class ConnectionCredentialUsageTypePicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ConnectionCredentialUsageType";
        this.bounded = true;
        this.enterpriseComponent = "PickList Generic";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.searchSpecification = null;
        this.sortSpecification = null;
        this.static = true;
        this.typeField = "Type";
        this.typeValue = "Connection Credential Usage";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ConnectionCredentialUsageTypePicklistMetadata;
